import { ApolloClient } from "@apollo/client";
import { toast } from "burnt";
import RequestPresetDocument from "src/api/graphql/__generated__/documents/RequestPresetDocument";
import { prompt } from "src/swsh-native";

const handleRequestTemplate = async ({
	apolloClient,
	communityId,
	gatheringId,
	onPressSubmit,
	onPressCancel,
}: {
	apolloClient: ApolloClient<object>;
	communityId?: string;
	gatheringId?: string;
	onPressSubmit?: (requestText?: string) => Promise<void> | void;
	onPressCancel?: () => Promise<void> | void;
}) => {
	const title = "Request templates";
	const message = `Request a template${communityId ? " for your group" : " for your album"}`;

	prompt({
		title,
		message,
		buttons: [
			{
				style: "default",
				text: "Submit",
				onPress: async (requestText) => {
					await apolloClient.mutate({
						mutation: RequestPresetDocument,
						variables: {
							input: {
								communityId,
								gatheringId,
								requestText,
							},
						},
					});
					await onPressSubmit?.(requestText);
					toast({
						preset: "done",
						title: "Success!",
						message: "Your template request has been sent",
					});
				},
			},
			{
				style: "cancel",
				text: "Cancel",
				onPress: async () => {
					await onPressCancel?.();
				},
			},
		],
	});
};

export default handleRequestTemplate;
